import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sifcore_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const branch = localStorage.getItem("sifcore_branch");
  if (branch && branch !== "all") config.headers["X-Branch-Id"] = branch;
  return config;
});

// Session expiration handling: clear token and bounce to login on 401.
api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const path = window.location.pathname;
    const onAuthPage = ["/login", "/register", "/forgot-password", "/reset-password"].includes(path);
    if (status === 401 && !onAuthPage) {
      localStorage.removeItem("sifcore_token");
      window.location.assign("/login");
    }
    return Promise.reject(error);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
